import React from "react";
import { Box, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import FormFader from "../../Common/Fader/FormFader";
import FormSubmit from "../../Common/FormSubmit/FormSubmit";
import { translate } from "../../../../services/translations/translations";
import { dateFieldDefault, isNumber, requiredValidator } from "../../../../services/validationRules";
import { useForm } from "../../../../provider/Form/FormProvider";
import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import Typography from "@mui/material/Typography";
import FormLegend from "../../Common/FormLegend/FormLegend";
import ValidatorDateField from "../../../FormFields/ValidatorDateField";
import { ContractDetailsProps } from "../../../../types/ContractDetailsProps";
import wizardStyle from "../../wizardStyle";

export default function EventContractDetails({ submitProps }: ContractDetailsProps) {
  const { values, handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Ihr Vertrag
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>Details zu Ihrem Vertrag</strong>
              </FormLegend>
            </Grid>

            <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
              <FormLegend>{translate(`${values.name}.reasonForDispute.question`, values)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorSelectField
                label={translate(`${values.name}.reasonForDispute.label`, values)}
                name="reasonForDispute"
                validators={[requiredValidator("Bitte geben Sie das Problem an.")]}
              >
                <MenuItem value="cancelled">{translate(`${values.name}.reasonForDispute.options.cancelled.label`, values)}</MenuItem>
                <MenuItem value="cancellationRefused">{translate(`${values.name}.reasonForDispute.options.cancellationRefused.label`, values)}</MenuItem>
                <MenuItem value="other">{translate(`${values.name}.reasonForDispute.options.other.label`, values)}</MenuItem>
              </ValidatorSelectField>
            </Grid>

            <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
              <FormLegend>{translate(`${values.name}.eventType.question`, values)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorSelectField
                label={translate(`${values.name}.eventType.label`, values)}
                name="eventType"
                helperText={translate(`${values.name}.eventType.helperText`, values)}
              >
                <MenuItem value="private">{translate(`${values.name}.eventType.options.private.label`, values)}</MenuItem>
                <MenuItem value="public">{translate(`${values.name}.eventType.options.public.label`, values)}</MenuItem>
              </ValidatorSelectField>
            </Grid>

            {values.eventType === "public" && (
              <>
                <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
                  <FormLegend>{translate(`${values.name}.contractNumber.question`, values)}</FormLegend>
                </Grid>
                <Grid size={12}>
                  <ValidatorTextField
                    label={translate(`${values.name}.contractNumber.label`, values)}
                    name="contractNumber"
                    helperText={translate(`${values.name}.contractNumber.helperText`, values)}
                    validators={[requiredValidator("Bitte geben Sie die Buchungs- oder Ticketnummer an")]}
                  />
                </Grid>

                <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
                  <FormLegend>{translate(`${values.name}.numberOfTickets.question`, values)}</FormLegend>
                </Grid>
                <Grid size={12}>
                  <ValidatorTextField
                    name="numberOfTickets"
                    label={translate(`${values.name}.numberOfTickets.label`, values)}
                    validators={[{ validator: isNumber, message: "Bitte geben Sie die Anzahl Der Tickets Zahl an, z.B. 2" }]}
                  />
                </Grid>
              </>
            )}

            <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
              <FormLegend>{translate(`${values.name}.eventTitle.question`, values)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField
                name="eventTitle"
                label={translate(`${values.name}.eventTitle.label`, values)}
                helperText={translate(`${values.name}.eventTitle.helperText`, values)}
                validators={[requiredValidator("Bitte nennen Sie uns den Namen der Veranstaltung.")]}
              />
            </Grid>

            <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
              <FormLegend>{translate(`${values.name}.eventCity.question`, values)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField
                name="eventCity"
                label={translate(`${values.name}.eventCity.label`, values)}
                validators={[requiredValidator("Bitte nennen Sie uns die Stadt in der das Events stattfinden soll.")]}
              />
            </Grid>

            <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
              <FormLegend>{translate(`${values.name}.eventDate.question`, values)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorDateField
                label={translate(`${values.name}.eventDate.label`, values)}
                name="eventDate"
                validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
